import { gql } from '@apollo/client';

export const ALL_ORGANISATION_USERS = gql`
  query AllOrganisationUsers($input: OrganisationUserFilterInput!) {
    users: allOrganisationUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          email
          firstName
          lastName
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
            cohorts {
              id
              name
            }
          }
          funder {
            id
            name
          }
        }
      }
    }
  }
`;
